<div [formGroup]="form">
  <div class="card mt-3">
    <div class="card-header">
      <a id="TargetLichtbild"></a>
      <h3>
        <i class="icon-lichtbild"></i> <span i18n>Lichtbild</span>
        <span class="float_right" *ngIf="appConfig.isAssistantAvailable">
          <button type="button" class="btn btn-primary btn-assistent mb-1 me-1" (click)="enableAssistant()"
                  style="width: 170px; background-color: #367297">
            <i class="icon-assistant" style="font-size: 20px; vertical-align: text-bottom"></i>
            <span i18n>Assistent starten</span>
          </button>
        </span>
      </h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header card-header-detail" i18n>Lichtbild</div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <label for="scannertyp-lichtbild" i18n class="pull-right">Erfassen mit:</label>
                </div>
                <div class="col-md-4">
                  <select class="form-select form-select-sm mb-3"
                          id="scannertyp-lichtbild"
                          formControlName="scannertyp"
                          (change)="changeDevice()">
                    <option *ngFor="let listItem of erfassungListItems"
                            value="{{ listItem.key }}">{{ listItem.value }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4">
                  <button type="button" class="btn btn-primary  me-1 pull-left" (click)="captureLichtbild()"
                          style="background-color: #367297; width: 210px"
                  ><span i18n>Lichtbild erfassen</span></button>
                </div>
              </div>
              <div class="row" *ngIf="form.value.wasCapturingSuccessful === true">
                <div class="col-md-12" style="color: #4DBD74">
                  <span i18n>Das Lichtbild wurde erfasst.</span>
                </div>
              </div>
              <div class="row" *ngIf="form.value.wasCapturingSuccessful === false">
                <div class="col-md-12" style="color: red">
                  <span i18n>Das Lichtbild konnte nicht erfasst werden.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
